export default __webpack_public_path__ + "static/img-small3-7064179be884b22858d1538590f16ce1.jpg";